import { render, staticRenderFns } from "./FacebookResponsibleTable.vue?vue&type=template&id=c21591e2&scoped=true&"
import script from "./FacebookResponsibleTable.vue?vue&type=script&lang=js&"
export * from "./FacebookResponsibleTable.vue?vue&type=script&lang=js&"
import style0 from "./FacebookResponsibleTable.vue?vue&type=style&index=0&id=c21591e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21591e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VIcon,VSimpleTable})
